import React from "react";

export default function RecomendacionesGenerales() {
  return (
    <div className="p-4 max-w-xl mx-auto flex flex-col gap-4">
      {/* Encabezado */}
      <div className="flex items-center justify-center">
        <h4 className="font-bold text-center">Recomendaciones generales</h4>
      </div>

      {/* Texto + descargable */}
      <div className="flex flex-col gap-4 mt-2">

        {/* Recomendaciones */}
        <div className="bg-[#f4f8fc] p-6 rounded-lg shadow">
          <div className="text-justify space-y-4">
            <p>Coma en un ambiente tranquilo y relajado. Evite distracciones como la televisión o ruido ya que debe estar concentrado en el acto de comer.</p>

            <hr className="border-gray-300" />

            <p>Coma sentado, con la espalda recta y los pies apoyados en el suelo. Si no puede levantarse de la cama debe colocarse lo más incorporado posible con la espalda recta (elevar el cabecero de la cama y si no puede, ayúdese con cojines y almohadas).</p>

            <hr className="border-gray-300" />

            <p>Ingiera la comida por el lado sano.</p>

            <hr className="border-gray-300" />

            <p>Cuando trague debe hacerlo con la barbilla inclinada hacia el pecho así evita que la comida pase al tracto respiratorio.</p>

            <hr className="border-gray-300" />

            <p>Asegúrese que la boca está vacía antes de introducir otra cucharada de comida.</p>
          </div>
        </div>

        {/* Recuerde */}
        <div className="bg-[#dfeaf7] p-6 rounded-lg shadow">
          <p className="text-justify font-semibold mb-4">
            RECUERDE:
          </p>

          <ol className="text-justify list-decimal list-inside space-y-2">
            <li>Después de las comidas debe mantenerse incorporado entre 30-60 minutos.</li>
            <li>No utilice jeringas o cañitas.</li>
            <li>Mantenga una buena higiene de la boca.</li>
            <li>En caso de duda consulte con su profesional sanitario.</li>
          </ol>
        </div>

        {/* Descargable */}
        <div className="flex items-center">
          <p className="text-justify gap-4 mt-2 mb-4">
            Si desea obtener el descargable, pulse en el siguiente{" "}
            <a
              href="/docs/recomendaciones-generales.pdf"
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-600 hover:underline"
            >
            enlace
            </a>.
          </p>
        </div>
      </div>
    </div>
  );
}